import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue";
  import { getLotStatusClass } from "@/helpers/status";
  import { LotStatus } from "@/enums/LotStatus";
  import Modal from "@/components/ui/Modal.vue";

  interface Props {
    isOpen: boolean;
    selectedLotsCount: number;
    availableStatuses: string[];
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'BulkStatusUpdateModal',
  props: {
    isOpen: { type: Boolean },
    selectedLotsCount: {},
    availableStatuses: {}
  },
  emits: ["close", "confirm"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

  const props = __props;
  const emit = __emit;

  const selectedStatus = ref<string>("");

  const displayStatus = (status: string) =>
    status === LotStatus.EOI ? "Pre-Contract" : status;

  const getStatusClass = (status: string) =>
    getLotStatusClass(
      (status === LotStatus.EOI ? LotStatus.PRE_CONTRACT : status) as LotStatus
    );

  const selectStatus = (status: string) => {
    selectedStatus.value = status;
  };

  const close = () => {
    selectedStatus.value = "";
    emit("close");
  };

  const confirm = () => {
    if (selectedStatus.value) {
      emit("confirm", selectedStatus.value);
      close();
    }
  };

const __returned__ = { props, emit, selectedStatus, displayStatus, getStatusClass, selectStatus, close, confirm, ref, get getLotStatusClass() { return getLotStatusClass }, get LotStatus() { return LotStatus }, Modal }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})